import { HandleBtnAskClickProps } from '../../types/optimizerTable';
export const handleBtnAskClick = async ({
  targetTitle,
  price,
  option,
  optionId,
  setLoading,
  loading,
  onOpenChat,
  getMessagesForTopic,
  saveMessagesForTopic,
  askChat,
}: HandleBtnAskClickProps) => {
  setLoading({ ...loading, [option]: true });
  try {
    const messagesForTopic = getMessagesForTopic(option);
    if (messagesForTopic.length !== 0) {
      saveMessagesForTopic(option, messagesForTopic);
    } else {
      const results = await askChat(optionId, { targetTitle, price, option });
      saveMessagesForTopic(option, results);
    }
    localStorage.setItem('currentOptionId', optionId.toString());
    onOpenChat(option);
  } catch (error) {
    console.error(error);
  } finally {
    setLoading({ ...loading, [option]: false });
  }
};
